<template lang="html">
  <v-layout column class="event">
    <chat-user-header main-icon="history"
                      :event="_.head(event.items)"
                      :participants="participants">
      updated the load
    </chat-user-header>
    <v-flex xs12 sm12 class="text-xs-left event-line ml-1" align-center
            v-for="(event, idx) in event.items"
            :key="`timeline-event-${event.modifiedByUserId}-${event.timestamp}-${idx}`">
      <span class="pl-4 font-weight-light">{{event.attributeName}}
          <span v-if="oldValue(event)">changed from {{oldValue(event)}}</span>
          <span v-else>set</span>
          to {{theValue(event)}}
      </span>
    </v-flex>
    <v-flex xs12 sm2 v-if="showTime"
            class="text-sm-right text-sm-left event-line font-weight-light caption pr-2">
      <span>{{event.timestamp | formatDate}}</span>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import * as Timestamps from '@/types/timestamp';
import ChatUserHeader from './ChatUserHeader';

export default {
  name: 'ChangeLogEventGroup',
  components: {
    ChatUserHeader,
  },
  props: {
    event: {
      required: true,
      type: Object,
    },
    participants: {
      required: true,
      type: Array,
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    _() {
      return _;
    },
  },
  methods: {
    // defining it here so we can be a bit more precise about how we adjust to different TZs
    formatDate(ts) {
      if (ts) {
        return Timestamps.formattedDate(ts);
      }

      return ts;
    },
    oldString(event) {
      return _.get(event, 'oldStringValue');
    },
    oldBoolean(event) {
      const bool = _.get(event, 'oldBooleanValue');
      if (bool === true) {
        return 'true';
      }
      if (bool === false) {
        return 'false';
      }
      return undefined;
    },
    oldNumber(event) {
      return _.get(event, 'oldNumberValue');
    },
    oldTimestamp(event) {
      const ts = _.get(event, 'oldTimestampValue');
      return this.formatDate(ts);
    },
    oldValue(event) {
      return this.oldString(event) ||
             this.oldNumber(event) ||
             this.oldTimestamp(event) ||
             this.oldBoolean(event);
    },
    theString(event) {
      return _.get(event, 'stringValue');
    },
    theBoolean(event) {
      const bool = _.get(event, 'booleanValue');
      if (bool === true) {
        return 'true';
      }
      if (bool === false) {
        return 'false';
      }
      return undefined;
    },
    theNumber(event) {
      return _.get(event, 'numberValue');
    },
    theTimestamp(event) {
      const ts = _.get(event, 'timestampValue');
      return this.formatDate(ts);
    },
    theValue(event) {
      return this.theString(event) ||
             this.theNumber(event) ||
             this.theTimestamp(event) ||
             this.theBoolean(event);
    },
  },
};
</script>
<style lang="css" scoped>
  .event {
    border-left: 3px #F0AD4E solid;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeline/ChangeLogEventGroup.vue